import { Badge, Icon, Tooltip } from "@shopify/polaris"
import { NotificationMajor } from "@shopify/polaris-icons"
import React, { useContext, useEffect, useState } from "react"
import packageJSON from "../../package.json"
import { useFirestoreDataUpdate } from "../hooks/useFirestoreDataUpdate"
import { GlobalStateContext } from "./providers/GlobalStateProvider"
import { notifications } from "@mantine/notifications"
import { useTranslation } from "react-i18next"
import { openMCPInstructions } from "./MCPInstructions.jsx"

const updates = [
	{
		version: "9.0.0",
		date: "2026-06-30",
		htmlDescription: (
			<p>
				[Kopy MCP is Live] Now you can <b>import products</b> and{" "}
				<b>create product pages</b> with <b>our MCP</b>.{" "}
				<a
					style={{
						color: "#000",
						cursor: "pointer",
						textDecoration: "underline",
					}}
					onClick={openMCPInstructions}
				>
					Click here to connect the MCP
				</a>
			</p>
		),
	},
	{
		version: "8.0.0",
		date: "2026-01-14",
		htmlDescription: (
			<p>
				[Kopy Pages 2.0 is Live] Now you can{" "}
				<b>create branded product pages</b> and <b>stores</b> with{" "}
				<b>AI in 1 click</b>.{" "}
				<a style={{ color: "#000" }} href="/pages">
					Click here
				</a>{" "}
				to try it out Free!
			</p>
		),
	},
	{
		version: "7.1.0",
		date: "2025-04-17",
		description:
			"• Import and create product pages for Aliexpress, Shein and Shopify products faster with the new Kopy Chrome Extension update.",
	},
	{
		version: "7.0.0",
		date: "2024-10-21",
		description:
			"• Kopy Pages is here. Generate high-converting product pages in seconds with AI.",
	},
	{
		version: "6.4.0",
		date: "2024-09-06",
		description:
			"• Added ability to import from Temu for single product import.",
	},
	{
		version: "6.5.0",
		date: "2024-08-23",
		description: "• Added Kopy AI for Multiple Products Import.",
	},
	{
		version: "6.4.0",
		date: "2024-08-08",
		description:
			"• Added ability to import from Shein for single product import.",
	},
	{
		version: "6.3.0",
		date: "2024-08-01",
		description:
			"• Added ability to import from Alibaba for single product import.",
	},
	{
		version: "6.2.0",
		date: "2024-06-19",
		description:
			"• Added option to reset your store's Access Token manually in the Account section.",
	},
	{
		version: "6.1.0",
		date: "2024-06-14",
		description:
			"• Importing products with Kopy AI is now cheaper.\n• Added new Feedback panel for suggestions and ideas.\n• Added a confirmation popup shown before discarding unsaved changes when importing products.",
	},
	{
		version: "6.0.0",
		date: "2024-04-20",
		description:
			"• Kopy Protect is here.\n• Now you can protect your store from competitors, join Kopy Protect today!",
	},
	{
		version: "5.0.0",
		date: "2024-01-26",
		description:
			"• Kopy AI is here.\n• Enhance and reword your products with AI when importing.\n• Translate your products with AI when importing.",
	},
	{
		version: "4.4.0",
		date: "2023-11-13",
		description: "• The Kopy Chrome Extension is back.",
	},
	{
		version: "4.3.0",
		date: "2023-11-03",
		description:
			"• Added back the Collections picker.\n• Added setting to disable currency conversion.",
	},
	{
		version: "4.2.0",
		date: "2023-11-02",
		description: "• Added Staff Accounts.",
	},
	{
		version: "4.1.0",
		date: "2023-11-01",
		description:
			"• Visual tweaks everywhere!\n• Fixed CJDropshipping mobile links.",
	},
	{
		version: "4.0.0",
		date: "2023-10-26",
		description:
			"• New Kopy is now available outside of the Shopify Admin at app.kopy.app .",
	},
	{
		version: "3.9.0",
		date: "2023-10-03",
		description:
			"• Our Chrome Extension is now available. Check it out!\n• Added Affiliate program.",
	},
	{
		version: "3.8.0",
		date: "2023-08-11",
		description:
			"• Added ability to import from Amazon for single product import.\n• Bug fixes.",
	},
	{
		version: "3.7.0",
		date: "2023-07-19",
		description:
			"• Added ability to import from Etsy for single product import.\n• Added pagination in Import Multiple Products for stores with 5k+ products.\n• Bug fixes.",
	},
	{
		version: "3.6.0",
		date: "2023-07-06",
		description:
			"• Added Multilink Import. Import multiple products by inserting multiple product links or import a CSV file with product links.\n• Bug fixes.",
	},
	{
		version: "3.5.0",
		date: "2023-04-16",
		description:
			"• Improvements to products selector on multiple product import.\n• Added sorting and filtering by price on multiple product import.\n• Bug fixes.",
	},
	{
		version: "3.4.2",
		date: "2022-12-21",
		description:
			"• Fixed Aliexpress product import issues.\n• Added image carousel when previewing single product import",
	},
	{
		version: "3.4.0",
		date: "2022-12-16",
		description:
			"• Added ability to import from CJDropshipping for single product import.\n• Added taxable field.\n• Fixed Aliexpress importing issues.\n• Added CSV export option in single product import.\n• Added CSV export guide.",
	},
	{
		version: "3.3.0",
		date: "2022-11-23",
		description:
			"• Added ability to import from Aliexpress for single product import.",
	},
	{
		version: "3.2.0",
		date: "2022-11-18",
		description: "• Added custom Vendor field.",
	},
	{
		version: "3.1.0",
		date: "2022-11-08",
		description:
			"• Added Settings window.\n• Added Imported Products History.",
	},
	{
		version: "3.0.0",
		date: "2022-10-14",
		description: "• Bug fixes and improved stability.",
	},
	{
		version: "2.2.2",
		date: "2022-04-08",
		description:
			"• Added price inputs for individual products and variants.\n• Added price rounding.\n• Added ability to create collection before importing products.\n• Added popup contact form so you can reach us easier.",
	},
]

const Changelog = (props) => {
	const [open, setOpen] = useState(false)
	const { state, dispatch } = useContext(GlobalStateContext)
	const updateFirestoreUserData = useFirestoreDataUpdate()
	const { t } = useTranslation()

	const toggleOpen = () => {
		setOpen(!open)

		if (!state.hasReadLatestChanges) {
			dispatch({ hasReadLatestChanges: true })
			updateFirestoreUserData({
				readChanges: {
					[packageJSON.version]: true,
				},
			})
		}
	}

	useEffect(() => {
		if (
			!state.loadingUserData &&
			!state.hasReadLatestChanges &&
			state.readChanges
		) {
			try {
				const readChangesVersions = Object.keys(state.readChanges)
				const latestReadChangesVersion =
					readChangesVersions[readChangesVersions.length - 1]

				const unreadChangesVersions = updates
					.filter((update) => {
						const isGreaterThanLatestReadVersion =
							update.version > latestReadChangesVersion

						return (
							isGreaterThanLatestReadVersion &&
							!readChangesVersions.includes(update.version)
						)
					})
					.map((update) => update.version)

				unreadChangesVersions.map((notificationsVersion) => {
					const notification = updates.find(
						(update) => update.version === notificationsVersion,
					)

					notifications.show({
						title: `New Kopy update! - ${notificationsVersion}`,
						message:
							notification.htmlDescription ||
							notification.description
								.split("\n")
								.map((line, i) => <p key={i}>{line}</p>),
						withCloseButton: true,
						autoClose: false,
						withBorder: true,
						radius: "lg",
						icon: (
							<div
								style={{
									background: "#222",
									borderRadius: "100%",
									height: "1.6rem",
									width: "1.6rem",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<svg
									style={{
										width: "1.1rem",
										height: "1.1rem",
									}}
									viewBox="0 0 24 24"
								>
									<path
										fill="currentColor"
										d="M21 6.5c0 1.93-1.57 3.5-3.5 3.5S14 8.43 14 6.5S15.57 3 17.5 3S21 4.57 21 6.5m-2 5.29c-.5.13-1 .21-1.5.21A5.51 5.51 0 0 1 12 6.5c0-1.47.58-2.8 1.5-3.79A1.93 1.93 0 0 0 12 2c-1.1 0-2 .9-2 2v.29C7.03 5.17 5 7.9 5 11v6l-2 2v1h18v-1l-2-2v-5.21M12 23c1.11 0 2-.89 2-2h-4a2 2 0 0 0 2 2Z"
									></path>
								</svg>
							</div>
						),
						onClose: () =>
							updateFirestoreUserData({
								readChanges: {
									[notificationsVersion]: true,
								},
							}),
					})
				})
			} catch (error) {
				console.error("Error showing notifications", error)
			}
		}
	}, [state.loadingUserData])

	return (
		<Tooltip
			content={
				<div style={{ padding: "0.2rem 0.4rem" }}>
					<span style={{ fontSize: "0.8rem", color: "#222" }}>
						{t("header.changelog_tooltip")}
					</span>
				</div>
			}
		>
			<div
				style={{
					background: "#e7e7e7",
					borderRadius: "100%",
					padding: "0.4rem",
					position: "relative",
				}}
			>
				<div
					onClick={toggleOpen}
					style={{ cursor: "pointer", verticalAlign: "middle" }}
				>
					<Icon source={NotificationMajor} color="subdued" />
					{!state.hasReadLatestChanges && (
						<div
							style={{
								background: "red",
								borderRadius: "10rem",
								width: "0.5rem",
								height: "0.5rem",
								position: "absolute",
								top: "0.1rem",
								left: "0.1rem",
							}}
						></div>
					)}
				</div>
				{open && (
					<div
						className="shadow border"
						style={{
							position: "absolute",
							top: "2.5rem",
							right: "0rem",
							background: "white",
							borderRadius: "1rem",
							padding: "0.5rem 0.5rem 0.5rem 0rem",
							zIndex: 1,
						}}
					>
						<div
							style={{
								padding: "1rem",
								maxHeight: "25rem",
								width: "20rem",
								overflowY: "auto",
								display: "flex",
								flexDirection: "column",
								gap: "1rem",
							}}
						>
							{updates.map((update, i) => {
								const date = new Date(
									update.date,
								).toLocaleDateString()

								return (
									<div
										key={update.version}
										style={{
											paddingBottom: "0.5rem",
											borderBottom:
												i < updates.length - 1
													? "1px solid #eee"
													: "",
										}}
									>
										<div
											style={{
												display: "flex",
												gap: ".5rem",
											}}
										>
											<Badge
												status="success"
												size="small"
											>
												{update.version}
											</Badge>{" "}
											<Badge status="info" size="small">
												{date}
											</Badge>
										</div>
										<div
											style={{
												marginTop: "0.5rem",
												marginLeft: ".5rem",
												whiteSpace: "break-spaces",
												fontSize: "0.9rem",
											}}
										>
											{update.htmlDescription ||
												update.description}
										</div>
									</div>
								)
							})}
						</div>
					</div>
				)}
			</div>
		</Tooltip>
	)
}

export default Changelog
